import { render, staticRenderFns } from "./PaymentMethodViewGlobal.vue?vue&type=template&id=4c51a2b7"
import script from "./PaymentMethodViewGlobal.vue?vue&type=script&lang=js"
export * from "./PaymentMethodViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports